import "./style.css";
//youtube
export default function CardGrupo(props) {
	return (
		<>
			<div key={props.key} className="col-md-3 col-sm-4 mt-3 mb-4 card-modulo">
				<div
					onClick={(e) => props.onClick(props.id_modulo, props.identificador)}
					className="services-item text-center card-content"
				>
					<h5>{props.descricao}</h5>
					<img className="img-modulo" src={props.url_foto} alt="" />
				</div>
			</div>
		</>
	);
}
